import { createFileRoute, notFound } from "@tanstack/react-router"
import { BlogArticle } from "@/components/blog-page"
import { blogPosts } from "@/lib/blog"
import { publicPageHead } from "@/lib/seo"

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const post = blogPosts.find((entry) => entry.slug === params.slug)
    if (!post) throw notFound()
    return post
  },
  head: ({ loaderData }) =>
    loaderData
      ? publicPageHead({
          path: `/blog/${loaderData.slug}`,
          title: `${loaderData.title} | intoshort`,
          description: loaderData.description,
          article: { publishedAt: loaderData.publishedAt },
        })
      : {
          meta: [
            { title: "Guide not found | intoshort" },
            { name: "robots", content: "noindex,follow" },
          ],
        },
  component: BlogPost,
})

function BlogPost() {
  return <BlogArticle post={Route.useLoaderData()} />
}
